export default __webpack_public_path__ + "static/media/speaker.fda029f1.jpg";